import { engineApi } from './api';

const buildResult = (options = [], error = '') => ({ options, error });

export const fetchStates = async (countryCode) => {
  if (!countryCode) {
    return buildResult();
  }

  try {
    const { data } = await engineApi.get(`geo/states/${countryCode}`);

    return buildResult(data.states.map((s) => s.name));
  } catch (error) {
    console.error('Error fetching states', error);
    return buildResult([], 'No pudimos cargar las provincias. Intentá nuevamente.');
  }
};

export const fetchCities = async (countryCode, stateName) => {
  if (!countryCode || !stateName) {
    return buildResult();
  }

  try {
    const { data } = await engineApi.get(`geo/cities/${countryCode}/${stateName}`);

    return buildResult(data.cities.map((c) => c.name));
  } catch (error) {
    console.error('Error fetching cities', error);
    return buildResult([], 'No pudimos cargar las ciudades. Intentá nuevamente.');
  }
};
